export class ProfileEnum {

    static GENERAL_PRINCIPAL = 'Coordenador geral';
    static GENERAL_LAWYER = `Advogado geral`;
    static NPJ_LAWYER = `Advogado parfista`;
    static TEACHER = `Professor`;
    static SUPERADMIN = `Superadministrador`;
    static ADMIN = `Administrador`;
    static SECRETARY = `Secretaria`;
    static PRINCIPAL = `Coordenador`;
    static LAWYER = `Advogado`;
    static STUDENT = `Aluno`;
    static NPJ_SERVICE = `Atendimento`;

    static isGeneralProfile = (profile) => {
        return [this.GENERAL_LAWYER, this.GENERAL_PRINCIPAL].includes(profile);
    }
}
